// eslint-disable-next-line import/no-commonjs
module.exports = () => {
  return {};
};
